
<div class="row">
  <div class="col-12">
    <div class="row">
      <Toggler
        v-if="
          !entity.parentId && (!entity.children || !entity.children.length)
        "
        v-model="entity.isGroup"
        :label="__('entities.is-parent')"
        class="col-auto"
        name="is_group"
        :style="{ 'min-height': '70px' }"
      />

      <SelectField
        v-if="!entity.isGroup"
        v-model="entity.parentId"
        name="parent_id"
        :label="__('entities.parent')"
        class="col-md-3 col-sm-8 col-lg-3"
        :options="entitiesWithoutCurrentEntity"
      />

      <TextField
        v-model="entity.network"
        name="network"
        :label="__('entities.entity-network')"
        class="col-md-4 col-sm-8 col-lg-4"
      />

      <TextField
        v-model="entity.code"
        name="code"
        :label="__('common.reference')"
        :readonly="isCodeReadonly"
        class="col-lg-3 col-md-6 col-sm-12 form-group"
      >
        <template v-if="isReferenceGeneratable" #append>
          <div class="col-auto form-group">
            <b-button
              variant="primary"
              class="form-control"
              size="sm"
              @click="generateReference"
            >
              {{ __('buttons.generate-reference') }}
            </b-button>
          </div>
        </template>
      </TextField>
    </div>
  </div>

  <TextField
    v-model="entity.name"
    name="name"
    :label="__('common.name')"
    class="col-2"
    required
  />

  <TextField
    v-model="entity.legalName"
    name="legal_name"
    :label="__('common.legal-name')"
    class="col-4"
  />

  <TextField
    v-model="entity.tag"
    name="tag"
    :label="__('common.tag')"
    class="col-2"
  />

  <SelectField
    v-if="!entity.parentId"
    v-model="entity.type"
    name="type"
    :label="__('common.type')"
    class="col-4"
    :options="EntityModel.types()"
    required
  />

  <TextField
    v-model="entity.addressHouse"
    name="address_house"
    :label="__('address.house')"
    class="col-2"
  />

  <TextField
    v-model="entity.addressUnit"
    name="address_unit"
    :label="__('address.unit')"
    class="col-2"
  />

  <TextField
    v-model="entity.addressStreet"
    name="address_street"
    :label="__('address.street')"
    class="col-4"
  />

  <TextField
    v-model="entity.addressTown"
    name="address_town"
    :label="__('address.town')"
    class="col-4"
  />

  <TextField
    v-model="entity.addressPostCode"
    name="address_post_code"
    :label="__('address.post-code')"
    class="col-3"
  />

  <SelectField
    v-model="entity.addressCountry"
    name="address_country"
    :label="__('address.country')"
    class="col-md-5"
    autocomplete="off"
    :options="translatedCountries"
    required
    @onChange="fetchCounties"
  />

  <SelectField
    v-if="entity.addressCountry && counties.length"
    v-model="entity.addressCounty"
    :options="counties"
    name="address_county"
    :label="__('address.county')"
    class="col-md-3"
  />

  <TextField
    v-else
    v-model="entity.addressCounty"
    name="address_county"
    :label="__('address.county')"
    class="col-md-3"
  />

  <DateField
    v-model="entity.tobaStartDate"
    name="toba_start_date"
    :label="__('date.toba-start')"
    class="col-2"
  />

  <DateField
    v-model="entity.tobaEndDate"
    name="toba_end_date"
    :label="__('date.toba-end')"
    class="col-2"
  />

  <div class="col-12">
    <div class="row">
      <TextAreaField
        v-model="entity.bankDetails"
        :label="__('entities.bank-details')"
        :rows="2"
        :class="{ 'col-6': isAgentEntity, 'col-8': !isAgentEntity }"
      />

      <Toggler
        v-if="isAgentEntity"
        v-model="entity.isAutomatedStatement"
        name="is_automated_statement"
        :label="__('entities.is-automated-statement')"
        class="col-2"
      />

      <SelectField
        v-model="entity.paymentTermId"
        name="payment_term_id"
        :label="__('entities.payment-term')"
        class="col-2"
        :options="paymentTerms"
      />

      <Toggler
        v-model="entity.isMakingPayments"
        :label="__('entities.is-payment')"
        name="is_making_payments"
        class="col-2"
      />
    </div>
  </div>

  <TextAreaField
    v-model="entity.notes"
    :label="__('common.notes')"
    :description="__('entities.additional-info')"
    class="col-12"
  />
  <FormActions :on-submit="save" :on-cancel="onCancel" />
</div>
